import { useState } from 'react';
import { PAGINATION_DEFAULTS } from '../utils/reportConstants';

export const useReportState = () => {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [pagination, setPagination] = useState(PAGINATION_DEFAULTS);

  const updatePagination = (updates) => {
    setPagination(prev => ({ ...prev, ...updates }));
  };

  const resetToFirstPage = () => {
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  return {
    // State
    reports,
    isLoading,
    technicians,
    pagination,
    
    // Actions
    setReports,
    setIsLoading,
    setTechnicians,
    setPagination,
    updatePagination,
    resetToFirstPage
  };
};